module.exports = __webpack_public_path__ + "img/erc.c5890223.jpg";